/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type NotificationDeliveryChannelResponseDto = {
  /**
   * Unique identifier of the delivery channel record.
   */
  id: number;
  /**
   * Delivery channel type.
   */
  deliveryChannel: NotificationDeliveryChannelResponseDto.deliveryChannel;
  /**
   * Phone number used for delivery, including country code.
   */
  phoneNumber: string;
  /**
   * Target entity ID to which the notification was sent.
   */
  targetEntityId: number;
  /**
   * Target type for the notification delivery.
   */
  target: NotificationDeliveryChannelResponseDto.target;
  /**
   * Timestamp when the notification was sent.
   */
  sentAt?: string;
  /**
   * Timestamp when the notification was delivered.
   */
  deliveredAt?: string;
  /**
   * Delivery status description
   */
  status?: string;
};
export namespace NotificationDeliveryChannelResponseDto {
  /**
   * Delivery channel type.
   */
  export enum deliveryChannel {
    PUSH = 'PUSH',
    SMS = 'SMS',
    CALL = 'CALL',
  }
  /**
   * Target type for the notification delivery.
   */
  export enum target {
    OWNER = 'OWNER',
    EMERGENCY_CONTACT = 'EMERGENCY_CONTACT',
  }
}

